export default __webpack_public_path__ + "static/media/enhanced-retirement-sum-tablet.742ce8df.svg";